import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { Plus, Pencil, Trash2 } from "lucide-react";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle, AlertDialogTrigger } from "@/components/ui/alert-dialog";

const STATUS_LABEL = { draft: "Entwurf", published: "Veröffentlicht", archived: "Archiviert" };

export default function AdminPoems() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/admin/poems").then(({ data }) => setItems(data)).catch(() => {}).finally(() => setLoading(false));
  }, []);

  const del = async (id) => {
    try {
      await api.delete(`/admin/poems/${id}`);
      toast.success("Gedicht gelöscht");
      setItems((x) => x.filter((i) => i.id !== id));
    } catch { toast.error("Löschen fehlgeschlagen"); }
  };

  return (
    <div className="fade-in">
      <div className="flex items-center justify-between mb-8">
        <h1 className="font-serif text-4xl font-light">Gedichte</h1>
        <Link to="/admin/gedichte/neu"><Button data-testid="new-poem-button" className="bg-[#F4C542] text-[#32104F] hover:bg-[#D85CA4] rounded-md"><Plus className="w-4 h-4 mr-2" /> Neu</Button></Link>
      </div>

      {loading ? <p className="text-[#9A86B4]">Laden…</p> : items.length === 0 ? (
        <div className="bg-white border border-[#E7D8C6] p-12 text-center">
          <p className="font-serif text-2xl text-[#6E5A82]">Noch keine Gedichte</p>
          <Link to="/admin/gedichte/neu"><Button className="mt-4 bg-[#F4C542] text-[#32104F] rounded-md">Erstes Gedicht schreiben</Button></Link>
        </div>
      ) : (
        <div className="bg-white border border-[#E7D8C6] divide-y divide-[#F5EBDB]">
          {items.map((p) => (
            <div key={p.id} className="flex items-center gap-4 p-4" data-testid={`admin-poem-row-${p.id}`}>
              <div className="flex-1 min-w-0">
                <div className="font-serif text-xl truncate">{p.title}</div>
                <div className="text-xs text-[#9A86B4]">{p.category}</div>
              </div>
              <Badge variant={p.status === "published" ? "default" : "secondary"} className="rounded-md hidden sm:inline-flex">{STATUS_LABEL[p.status]}</Badge>
              <div className="flex gap-1">
                <Link to={`/admin/gedichte/${p.id}`}><Button size="icon" variant="ghost" data-testid={`edit-poem-${p.id}`}><Pencil className="w-4 h-4" /></Button></Link>
                <AlertDialog>
                  <AlertDialogTrigger asChild><Button size="icon" variant="ghost" data-testid={`delete-poem-${p.id}`}><Trash2 className="w-4 h-4" /></Button></AlertDialogTrigger>
                  <AlertDialogContent className="bg-white">
                    <AlertDialogHeader>
                      <AlertDialogTitle>Gedicht löschen?</AlertDialogTitle>
                      <AlertDialogDescription>„{p.title}“ wird unwiderruflich gelöscht.</AlertDialogDescription>
                    </AlertDialogHeader>
                    <AlertDialogFooter>
                      <AlertDialogCancel className="rounded-md">Abbrechen</AlertDialogCancel>
                      <AlertDialogAction onClick={() => del(p.id)} className="bg-destructive text-white rounded-md">Löschen</AlertDialogAction>
                    </AlertDialogFooter>
                  </AlertDialogContent>
                </AlertDialog>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
